import { Grid, Toolbar } from '@mui/material';
import React from 'react';

import NavbarContent, { NavbarContentProps } from './NavbarContent';

const Navbar: React.FC<NavbarContentProps> = ({
  title,
  userLoaded,
  userLoading,
  isClient,
  onOpenSidebarMobile,
  showSearchbar,
  BreadCrumbComponent,
  showBreadCrumb,
  showNavbarAuthActions,
  headerContent,
  ignoreHeaderPadding,
}) => {
  return (
    <Toolbar className={ignoreHeaderPadding ? 'px-0' : 'px-4 sm:px-9'}>
      <Grid container>
        {headerContent || (
          <NavbarContent
            title={title}
            userLoaded={userLoaded}
            userLoading={userLoading}
            isClient={isClient}
            onOpenSidebarMobile={onOpenSidebarMobile}
            showSearchbar={showSearchbar}
            BreadCrumbComponent={BreadCrumbComponent}
            showBreadCrumb={showBreadCrumb}
            showNavbarAuthActions={showNavbarAuthActions}
          />
        )}
      </Grid>
    </Toolbar>
  );
};

export default Navbar;
